import { Button } from "@circleco/compass/components/Button";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

interface AvatarPreviewBannerProps {
  onRestart: () => void;
}

export const AvatarPreviewBanner = ({
  onRestart,
}: AvatarPreviewBannerProps) => (
  <div
    className="bg-secondary mb-2 flex items-center gap-5 rounded-lg px-4 py-3"
    data-testid="avatar-preview-banner"
  >
    <div className="flex min-w-0 flex-1 items-center gap-3">
      <Icon name="eye-open" size="sm" />
      <Typography variant="label-sm" component="p">
        {t("community_inbox.avatar_preview")}
      </Typography>
    </div>
    <Button
      variant="outline"
      size="sm"
      type="button"
      startIcon="refresh"
      onClick={onRestart}
      data-testid="avatar-preview-restart"
    >
      {t("community_inbox.restart")}
    </Button>
  </div>
);
